import React, { FunctionComponent } from "react";
import NumberComponent, { NumberComponentProps } from "./NumberComponent";
import { VALUE_TYPE } from "c8-platform";
import { DEFAULT_INTEGER_FORMAT } from "csi/utility/numberUtility";

const IntegerComponent: FunctionComponent<NumberComponentProps> = (
	{
		valueType,
		...otherProps
	},
) => (
	<NumberComponent
		{...otherProps}
		format={otherProps.format || DEFAULT_INTEGER_FORMAT}
		valueType={VALUE_TYPE.INTEGER}
	/>
);

export default IntegerComponent;
